/**
 * 法規不合規項目的資料模型
 */
export interface law_unfit_list {
  id: string;
  companyid: string;
  topic: string;
  title: string;
  missionid: string;
  check_result_id: string; // 用於關聯檢查結果

  law_id: string;
  law_name: string;
  article_id: string;
  article_no: string;
  article_content: string;
  current_status: string;

  assignee: string;
  email: string;
  dueDate: string;

  riskOpportunity: string[];
  solution: string[];
  improvementContent: string;
  attachments: any[];

  status: string;
  priority: string;
  createdAt: number; // 保留字串格式用於顯示
  updatedAt: number; // 保留字串格式用於顯示
}

/**
 * 建立法規不合規項目的工廠函式
 */
export function createRegulationUnfitItem(item: Partial<law_unfit_list> = {}, companyid: string = ''): law_unfit_list {
  const now = new Date();
  const timestamp = Math.floor(now.getTime() / 1000); // 轉換為秒級時間戳

  return {

    id: "unfit_" + generateUniqueId(),
    check_result_id:item.id || '',


    companyid: item.companyid || companyid,
    topic: item.topic || '',
    title: item.title || '',
    missionid: item.missionid || '',

    law_id: item.law_id || '',
    law_name: item.law_name || '',
    article_id: item.article_id || '',
    article_no: item.article_no || '',
    article_content: item.article_content || '',
    current_status: item.current_status || '',

    assignee: item.assignee  || '',
    email: item.email || '',
    dueDate: item.dueDate || '',

    riskOpportunity: item.riskOpportunity || [],
    solution: item.solution || [],
    improvementContent: item.improvementContent || '',
    attachments: item.attachments || [],

    status: item.status || '',
    priority: item.priority || '',
    createdAt: timestamp,
    updatedAt: timestamp,
  };
}

/**
 * 生成唯一ID
 */
function generateUniqueId(): string {
  return Date.now().toString() + '-' + Math.random().toString(36).substring(2, 15);
}



